/**
 * Returns a default value if a value if value is undefined.
 * This doesn't set the value. It only returns either value or defaultValue
 *
 * @param {any} value value to check if undefined
 * @param {any} defaultValue default value to return if value is undefined
 * @returns {any}
 */
function setDefaultValue(value, defaultValue) {
  return value === undefined ? defaultValue : value;
}

export default setDefaultValue;
